<div class="udex-mb-24 udex-mb-lg-32 body--s" *ngIf="displayMessages()">
  <ng-container *ngIf="externalValidations">
    <udex-message-strip
      *ngFor="let externalValidation of externalValidations; let last = last"
      [design]="getFormattedSeverity(externalValidation.severity)"
      [hideCloseButton]="true"
      [ngClass]="{'udex-mb-8': !last}"
      status-type="Icon">
      <span>
        {{ externalValidation.description | cxTranslate }}
        <dcp-contact-us-link
          class="d-inline"
          [isEnd]="false"
          [innerText]="'configurator.error.general.buttonText'"></dcp-contact-us-link>
        {{ 'configurator.error.general.proceed' | cxTranslate }}
      </span>
    </udex-message-strip>
  </ng-container>
  <ng-container *ngIf="configuration?.validation">
    <div [ngClass]="{'udex-mt-8': externalValidations?.length > 0}">
      <ng-container *ngFor="let validation of configuration.validation; let last = last">
        <udex-message-strip
          (click)="openSupportForm($event)"
          [design]="getFormattedSeverity(validation.severity)"
          [hideCloseButton]="true"
          [ngClass]="{'udex-mb-8': !last}"
          status-type="Icon">
          <span class="" style="vertical-align: middle" [innerHtml]="validation.description"></span>
          <span *ngIf="validation.code"
            >&nbsp;{{ 'configurator.error.code' | cxTranslate: {errorCode: validation.code} }}
          </span>
          <udex-link
            (click)="handleAction(validation.button)"
            (keydown.enter)="handleAction(validation.button)"
            *ngIf="validation.button"
            class="body--s"
            data-cy="validation-button"
            design="Default"
            >{{ validation.button.name }}
          </udex-link>
        </udex-message-strip>
        <ng-template #modalContentTemplate>
          <p class="body--xs" [innerHtml]="validation?.button?.content?.body"></p>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
</div>
